import { Injectable  } from '@angular/core';

@Injectable ()
export class VehicleService {
  vehicle: number;

  setPayment(value) {
    this.vehicle = value;
  }
  getPayment() {
    return this.vehicle;
  }

}
